import { render, staticRenderFns } from "./DictionaryTable.vue?vue&type=template&id=32928482"
import script from "./DictionaryTable.vue?vue&type=script&lang=js"
export * from "./DictionaryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports